import styled from "styled-components";
import { color, hoverColor } from "@m/alchemy-theme";
export const Link = styled.span.attrs({ role: "button" }) `
  color: ${color("typeLink")};
  cursor: pointer;
  text-decoration: ${(props) => (props.isActive ? "underline" : "inherit")};
  background-color: ${(props) => props.isActive ? color("hint", { palette: "expressiveInformative" }) : "transparent"};

  &:focus,
  &:hover {
    color: ${({ linkColor }) => linkColor || hoverColor("typeLink")};
    text-decoration: underline;
  }
`;
